// src/components/dashboard/KPICards.js
import React from 'react';
import { UserGroupIcon, CurrencyDollarIcon, TagIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const KPICards = () => {
    const kpis = [
        { title: 'Total Members', value: '1,234', icon: UserGroupIcon, change: '+5%', trend: 'up' },
        { title: 'Revenue from Loyalty', value: 'ZAR12,500', icon: CurrencyDollarIcon, change: '+12%', trend: 'up' },
        { title: 'Rewards Redeemed', value: '256', icon: TagIcon, change: '-3%', trend: 'down' },
        { title: 'Avg. Repeat Purchase Rate', value: '45%', icon: ArrowPathIcon, change: '+2%', trend: 'up' },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {kpis.map((kpi) => (
                <div key={kpi.title} className="bg-white rounded-lg shadow-md p-6 flex flex-col justify-between">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-gray-700">{kpi.title}</h3>
                        <kpi.icon className="h-8 w-8 text-indigo-500" />
                    </div>
                    <div className="flex items-baseline mb-2">
                        <span className="text-4xl font-bold text-gray-900">{kpi.value}</span>
                        <span className={`ml-2 text-sm font-medium ${kpi.trend === 'up' ? 'text-green-500' : 'text-red-500'}`}>
              {kpi.change}
            </span>
                    </div>
                    <p className="text-sm text-gray-500">vs. last month</p>
                </div>
            ))}
        </div>
    );
};

export default KPICards;